export default __webpack_public_path__ + "static/media/2.abe0f087.jpg";